/**
 * Copyright 2023 Design Barn Inc.
 */

import axios from 'axios';

export interface ISessionResponse {
  active: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  expires_at: string | undefined;
  token: string | undefined;
}

export async function deimosGetSession(): Promise<ISessionResponse | null> {
  let sessionData: ISessionResponse;

  try {
    const response = await axios.post<ISessionResponse>(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      process.env['NEXT_PUBLIC_DEIMOS_SESSION_URL']!,
      {},
      { withCredentials: true },
    );

    sessionData = response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return null;
  }

  if (!sessionData.active || !sessionData.expires_at || !sessionData.token) {
    // eslint-disable-next-line no-console
    console.error('Invalid session API response.');

    return null;
  }

  return sessionData;
}
